import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useCurrentPage from "../../../hooks/useCurrentPage";
import axios from "axios";
import MainServices from "../../../services/MainServices";
import moment from "moment";
import PageLoader from "../../../assets/loaders/PageLoading";
import ApprovalStatusModal from "../../../assets/modal/ApprovalStatusModal";
import { notifySuccess, notifyWarn } from "../../../assets/elements/Toast";
import { Button, Modal } from "react-bootstrap";
import { Table } from "reactstrap";
import "./PlantDetails.scss";
import editicon from "../../../assets/images/icons/edit.svg";
import PermissionFunctions from "../../../assets/functions/PermissionFunctions";
import { Formik } from "formik";
import useAuth from "../../../hooks/useAuth";
import useFeatureSetting from "../../../hooks/useFeatureSetting";
import { InputGroup, Form } from "react-bootstrap";
import { PrimaryInput } from "../../../assets/FormElements";
import CustomErrorMessage from "../../../assets/elements/ErrorMessage";
import { squareBackIcon, backarrowicon } from "../../../assets/images/icons/icons";
import ButtonLoading from "../../../assets/loaders/ButtonLoading";
import Select from "react-select";
import * as Yup from "yup";
import Cross from "../../../assets/images/icons/cross.svg";
import IsWorkflowSlug from "../../../assets/modal/IsWorkflowSlug";
import CustomDigitalSignature from "../../../assets/modal/CustomDigitalSignature";
import AsyncSelect from "react-select/async";
import TimingFunctions from "../../../assets/functions/TimingFunctions";
import Workflows from "../../../assets/workflows/Workflows";
import WorkflowHistory from "../../../assets/workflows/WorkflowHistory";

const PlantDetails = () => {
  const branchSchema = Yup.object().shape({
    branchId: Yup.object()
      .shape({
        value: Yup.string().required("Branch is required"),
      })
      .required("Branch is required"),
    plantName: Yup.string()
      .transform((value) => value.trim())
      .matches(
        /^[a-zA-Z0-9\s]*$/,
        "Plant Name cannot contain special characters"
      )
      .required("Plant Name is Required"),
    plantCode: Yup.string()
      .transform((value) => value.trim())
      .required("Plant Code is Required"),
    address: Yup.string()
      .transform((value) => value.trim())
      .required("Plant Address is Required"),
  });

  const updateBranchSchema = Yup.object().shape({
    branchId: Yup.object()
      .shape({
        value: Yup.string().required("Branch is required"),
      })
      .required("Branch is required"),
    plantName: Yup.string()
      .transform((value) => value.trim())
      .matches(
        /^[a-zA-Z0-9\s]*$/,
        "Plant Name cannot contain special characters"
      )
      .required("Plant Name is Required"),
    plantCode: Yup.string()
      .transform((value) => value.trim())
      .required("Plant Code is Required"),
    address: Yup.string()
      .transform((value) => value.trim())
      .required("Plant Address is Required"),
    workflows: Yup.array()
      .of(
        Yup.object().shape({
          users: Yup.array().required("users array is required"),
        })
      )
      .test("at-least-one-user", "Workflow is Required", function (workflows) {
        return workflows.some(
          (workflow) => workflow.users && workflow.users.length > 0
        );
      }),
    // password: Yup.string().transform((value) => value.trim()).required("Password is Required"),
  });

  const { updateCurrentPage } = useCurrentPage();
  const {
    getPlantById,
    updateEventWorkflowReview,
    getEventWorkflowById,
    getWorkFlowsByType,
    getWorkFlowHistoryByType,
    updatePlant,
    getBranchMasters,
    getWorkflowsBySlug,
  } = MainServices();
  const [pageLoading, setPageLoading] = useState(0);
  const [plantMasters, setPlantMasters] = useState([]);
  const [workflowMasters, setWorkflowMasters] = useState({});
  const location = useLocation();
  const [approvedLoading, setApprovedLoading] = useState(0);
  const [approvedModal, setApprovedModal] = useState(false);
  const [sopWorkFlows, setSopWorkFlows] = useState([]);
  const [workFlowHisories, setWorkFlowHisories] = useState([]);
  const navigate = useNavigate();
  const [buttonLoading, setButtonLoading] = useState(0);
  const [selectedPlant, setSelectedPlant] = useState({});
  const [addPlantModal, setAddPlantModal] = useState(false);
  const [reinitiateClicked, setReinitiateClicked] = useState(false);
  const { user } = useAuth();
  const [branchChange, setBranchChange] = useState(false);
  const [intiLoading, setIntiLoading] = useState(0);
  //url Params
  const publicId = new URLSearchParams(location.search).get("publicId");
  const refId = new URLSearchParams(location.search).get("refId");
  const workflowConcurrencystamp = new URLSearchParams(location.search).get(
    "workflowConcurrencystamp"
  );
  const [branches, setBranches] = useState([]);
  const { grantPermission } = PermissionFunctions();
  const { updateSettingContext, setting } = useFeatureSetting();
  const edit = new URLSearchParams(location.search).get("edit");
  const [editInitiated, setEditInitiated] = useState(false);
  const [workflowAssign, setWorkflowAssign] = useState({});
  const [isWorkflowFlag, setIsWorkflowFlag] = useState({});
  const [workflowDataSet, setWorkflowDataSet] = useState("");
  const [workflowModal, setWorkflowModal] = useState(false);
  const [digitalSignatureModal, setDigitalSignatureModal] = useState(false);
  const { deBounce } = TimingFunctions();
  const [isStatusUpdate, setIsStatusUpdate] = useState(0);

  useEffect(() => {
    updateCurrentPage({
      title: "Plant",
      subtitle: "Details",
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBranches();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateSettingContext("plant");
  }, []);

  useEffect(() => {
    if (publicId) {
      getPlantMasterByStatus();
      getSopWorkflows();
      getWorkflowHistory();
      getIsWorkflowSlug();
    }
    // eslint-disable-next-line
  }, [publicId]);

  useEffect(() => {
    if (refId) {
      getWorkflowById();
    }
    // eslint-disable-next-line
  }, [refId]);

  const getPlantMasterByStatus = async () => {
    setPageLoading(true);
    const details = {};

    await axios
      .all([getPlantById(details, publicId)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let plants = resData.data ? resData.data : [];
            setPlantMasters(plants);
            if (edit === "true" && !editInitiated) {
              onAddPlant(plants);
              setEditInitiated(true);
            }
            setPageLoading(false);
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting Plants");
      });
  };

  const getWorkflowById = async () => {
    setPageLoading(true);
    const details = {
      filters: [{ key: "publicId", eq: refId }],
    };

    await axios
      .all([getEventWorkflowById(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let workflows = resData.data ? resData.data : [];
            setWorkflowMasters(workflows[0]);
            setPageLoading(false);
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in getting Event Workflow");
      });
  };

  const updateWorkflowStatus = async (values) => {
    setApprovedLoading(true);
    const details = {
      workflowStatus: values.status?.value,
      //   email: values.user_id,
      ...(values?.password && { password: values.password }),
      comments: values.comment,
    };
    await axios
      .all([
        updateEventWorkflowReview(details, refId, workflowConcurrencystamp),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            notifySuccess("Status changed successfully");
            setIsStatusUpdate(Math.random());
            setApprovedLoading(false);
            onApprovedStatusModal();
            getPlantMasterByStatus();
            getWorkflowById();
            getSopWorkflows();
            getWorkflowHistory();
          } else {
            message && notifyWarn(message);
            setApprovedLoading(false);
          }
        } else {
          setApprovedLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in status update");
      });
  };

  const getSopWorkflows = async () => {
    const details = {
      workFlowType: "plant",
      sorting: [{ key: "id", direction: "asc" }],
    };
    await axios
      .all([getWorkFlowsByType(details, publicId)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let workflows = resData.data ? resData.data : {};
            setWorkflowAssign(workflows);
            workflows = workflows.eventWorkflows
              ? workflows.eventWorkflows
              : [];
            setSopWorkFlows(workflows);
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting workflows");
      });
  };

  const getWorkflowHistory = async () => {
    const details = {
      sorting: [{ key: "id", direction: "desc" }],
    };
    await axios
      .all([getWorkFlowHistoryByType(details, publicId)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let workflowHistory = resData.data ? resData.data : [];
            setWorkFlowHisories(workflowHistory);
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting workflows");
      });
  };

  const updatePlantMaster = async (values) => {
    setButtonLoading(true);
    let workflowInfo = values?.workflows || [];
    let workflowFlag = false;
    workflowInfo =
      workflowInfo.length > 0
        ? workflowInfo.map((each) => ({
            ...each,
            users: each?.users?.map((user) => {
              workflowFlag = true;
              return {
                value: user?.publicId,
              };
            }),
            ...(each?.no_of_approvals
              ? { no_of_approvals: each?.no_of_approvals }
              : {
                  no_of_approvals: each?.users && each?.users.length,
                }),
          }))
        : [];

    const details = {
      plantName: values.plantName,
      address: values.address,
      plantCode: values.plantCode,
      ...(values?.remark && { remark: values?.remark }),
      ...(values?.password && { password: values?.password }),
      ...(branchChange && { branchId: values?.branchId?.publicId }),
    };
    if (workflowFlag) {
      details.workflowInfo = workflowInfo;
    }

    await axios
      .all([
        updatePlant(
          details,
          selectedPlant.publicId,
          selectedPlant.concurrencyStamp
        ),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            getPlantMasterByStatus();
            onAddPlant(false);
            setDigitalSignatureModal(false);
            values?.status === "approved" && navigate(-1);
            setSelectedPlant("");
            notifySuccess("Plant  Updated Successfully");
            setButtonLoading(false);
          } else {
            message && notifyWarn(message);
            setButtonLoading(false);
          }
        } else {
          setButtonLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in updating Plant");
      });
  };

  const updateBranchIntiated = async (values) => {
    setIntiLoading(true);
    const details = {
      plantName: values.plantName,
      address: values.address,
      plantCode: values.plantCode,
      ...(values?.password && { password: values?.password }),
      ...(branchChange && { branchId: values?.branchId?.publicId }),
      ...(values?.password && { password: values?.password }),
      reinitiateWorkflowAssignId: workflowAssign.publicId,
      status: "reinitiated",
    };
    await axios
      .all([
        updatePlant(
          details,
          selectedPlant.publicId,
          selectedPlant.concurrencyStamp
        ),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            getSopWorkflows();
            onAddPlant();
            getPlantMasterByStatus({}, publicId);
            setReinitiateClicked(false);
            setDigitalSignatureModal(false);
            setIsStatusUpdate(Math.random());
            notifySuccess("Branch Master Updated Successfully");
            setIntiLoading(false);
          } else {
            message && notifyWarn(message);
            setIntiLoading(false);
          }
        } else {
          setIntiLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in updating Branch Master");
      });
  };

  const getBranches = async (filters) => {
    setPageLoading(true);
    const details = {
      filters,
      status: "active",
    };
    let results = await getBranchMasters(details)
      .then((res) => {
        if (res) {
          let resData = res;
          if (resData.success) {
            let branches = resData.data ? resData.data : [];
            branches = branches.map((_) => {
              return {
                ..._,
                label: _?.branchName,
                value: _?.publicId,
              };
            });
            branches.unshift({ label: "--All--", value: "" });
            setBranches(branches);
            setPageLoading(false);
            return branches;
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting branches");
      });
    return results;
  };

  const getIsWorkflowSlug = async () => {
    const details = {};
    await axios
      .all([getWorkflowsBySlug(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let isWorkflow = resData?.data ? resData?.data : {};
            isWorkflow = isWorkflow?.content
              ? JSON.parse(isWorkflow?.content)
              : {};
            setIsWorkflowFlag(isWorkflow);
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in getting measurement types");
      });
  };

  //functions
  const onSearchBrandDebounce = (inputValue, callback) => {
    deBounce(() => onSearchBranch(inputValue, callback), 1000);
  };

  const onSearchBranch = async (inputValue, callback) => {
    if (!inputValue) {
      callback(getBranches);
      return;
    }

    let filter = [
      {
        key: "branchName",
        iLike: inputValue,
      },
      { key: "status", eq: "approved" },
      { key: "recordStatus", eq: "active" },
    ];
    let options = await getBranches(filter);
    callback(options);
  };

  const handleWorkflowAssignUpdate = (updatedWorkflowAssign) => {
    setWorkflowAssign(updatedWorkflowAssign);
  };

  const onManageWorkflow = ({ values, setFieldValue }) => {
    setWorkflowDataSet({
      workflows: values?.workflows,
      setFieldValue,
    });
    setWorkflowModal((prev) => !prev);
  };

  const onApprovedStatusModal = () => {
    setApprovedModal(!approvedModal);
  };
  const onAddPlant = (selected) => {
    if (selected) {
      setSelectedPlant(selected);
    } else {
      setSelectedPlant("");
    }
    setAddPlantModal(!addPlantModal);
  };

  const onDigitalSignatureModal = () => {
    setDigitalSignatureModal(!digitalSignatureModal);
  };

  return (
    <div className="training-sop-main">
      <div className="admin-popular-main lims-details-page tms-inventory-details-page">
        <div className="details-page-toolbar">
          <div className="details-page-toolbar__left">
            <button
              type="button"
              className="btn btn-link details-page-back-btn"
              onClick={() => navigate(-1)}
              title="Back"
              aria-label="Go back"
            >
              {backarrowicon}
            </button>
            <div className="details-page-title-block">
              <p className="content-header-main mb-0">Plant Details</p>
            </div>
          </div>
          <div className="details-page-toolbar__right">
            <div
              style={{ cursor: "pointer" }}
              onClick={() => onAddPlant(plantMasters)}
            >
              <img src={editicon} alt="Edit icon" />
            </div>
            {refId && workflowMasters?.workflowStatus === "pending" && (
              <Button className="details-page-action-btn theme-btn-main" onClick={onApprovedStatusModal}>Update Status</Button>
            )}
          </div>
        </div>
        {pageLoading ? (
          <PageLoader />
        ) : plantMasters ? (
          <div className="details-page-content">
            <div className="details-card">
              <div className="details-card__header">
                <h3 className="details-card__title">Overview</h3>
              </div>
              <div className="details-grid">
                <div className="details-grid__item">
                  <div className="details-grid__label">Name</div>
                  <div className="details-grid__value">{plantMasters?.plantName}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Code</div>
                  <div className="details-grid__value">{plantMasters?.plantCode}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Address</div>
                  <div className="details-grid__value">{plantMasters?.address}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Branch</div>
                  <div className="details-grid__value">{plantMasters?.branch?.branchName}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Created At</div>
                  <div className="details-grid__value">{moment(plantMasters?.createdAt).format("DD-MM-YYYY")}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Status</div>
                  <div className="details-grid__value">
                    {plantMasters?.status === "approved"
                      ? plantMasters?.recordStatus
                      : plantMasters?.status}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="no-data-found-main">No Plant Found</div>
        )}

        <Workflows
          publicId={publicId}
          isStatusUpdate={isStatusUpdate}
          onWorkflowAssignUpdate={handleWorkflowAssignUpdate}
          initiator={plantMasters?.createdBy?.empName}
        />

        <WorkflowHistory publicId={publicId} isStatusUpdate={isStatusUpdate} />
      </div>
      <Modal
        centered
        show={addPlantModal}
        onHide={onAddPlant}
        className="add-department-modal-main"
        size="lg"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            Update Plant
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-department-modal-body">
          <p className="mb-4 add-department-modal-content-text">
            Please enter plant name, address and code for plant Modification.
          </p>
          <Formik
            initialValues={{
              plantName: selectedPlant?.plantName || "",
              address: selectedPlant?.address || "",
              plantCode: selectedPlant?.plantCode || "",
              branchId: selectedPlant?.branch?.publicId
                ? {
                    label: selectedPlant.branch.branchName,
                    value: selectedPlant.branch.publicId,
                  }
                : "",
              workflow_name: selectedPlant?.name || "",
              workflows: selectedPlant?.workflowData || [
                {
                  workflow: "reviewer",
                  users: [],
                  no_of_approvals: "",
                },
                {
                  workflow: "approver",
                  users: [],
                  no_of_approvals: "",
                },
              ],
              disabled:
                selectedPlant?.disabled === false ||
                selectedPlant?.disabled === "No"
                  ? true
                  : false,
            }}
            validationSchema={
              setting?.workflow_required === "true"
                ? updateBranchSchema
                : branchSchema
            }
            onSubmit={(values) => {
              if (setting.digital_signature) {
                setSelectedPlant({ ...selectedPlant, ...values });
                onDigitalSignatureModal();
              } else {
                updatePlantMaster(values);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              dirty,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form className="form" onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label className="form-label" for="branchId">
                    Branch
                    <span className="required-star"> *</span>
                  </label>
                  <div className="form-control-wrap">
                    <AsyncSelect
                      id="branch"
                      name="branchId"
                      placeholder="Select..."
                      onChange={(e) => {
                        setBranchChange(true);
                        setFieldValue("branchId", e);
                      }}
                      value={values.branchId}
                      defaultOptions={branches}
                      options={branches}
                      className="sop-custom-form-select"
                      loadOptions={onSearchBrandDebounce}
                      onBlur={handleBlur}
                      cacheOptions
                    />
                    {errors?.branchId?.value && touched.branchId ? (
                      <span className="error">{errors?.branchId?.value}</span>
                    ) : (
                      <CustomErrorMessage
                        name="branchId"
                        errors={errors}
                        touched={touched}
                      />
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label" for="contact_number">
                    Plant Name
                    <span className="required-star"> *</span>
                  </label>
                  <PrimaryInput
                    placeholder="Enter Plant Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.plantName}
                    name="plantName"
                    id="plantName"
                  />
                  <CustomErrorMessage
                    name="plantName"
                    errors={errors}
                    touched={touched}
                  />
                </div>

                <div className="form-group mt-3">
                  <label className="form-label" for="contact_number">
                    Plant Code
                    <span className="required-star"> *</span>
                  </label>
                  <PrimaryInput
                    placeholder="Enter Plant Code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.plantCode}
                    name="plantCode"
                    id="plantCode"
                  />
                  <CustomErrorMessage
                    name="plantCode"
                    errors={errors}
                    touched={touched}
                  />
                </div>

                <div className="form-group mt-3">
                  <label className="form-label" for="contact_number">
                    Plant Address
                    <span className="required-star"> *</span>
                  </label>
                  <textarea
                    className="form-control employee-custom-form-control"
                    placeholder="Enter Plant Address"
                    aria-label="With textarea"
                    name="address"
                    id="address"
                    value={values.address}
                    onChange={handleChange}
                  ></textarea>
                  <CustomErrorMessage
                    name="address"
                    errors={errors}
                    touched={touched}
                  />
                </div>

                {isWorkflowFlag &&
                  isWorkflowFlag?.standard_workflow === "false" &&
                  setting?.workflow_disabled === "false" &&
                  selectedPlant?.status === "approved" && (
                    <>
                      <div
                        className="my-4"
                        style={{ borderBottom: "1px dashed #000" }}
                      />
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0" style={{ fontWeight: 500 }}>
                          Manage Workflow :
                          {setting?.workflow_required === "true" && (
                            <span style={{ color: "#f00" }}> *</span>
                          )}
                        </p>
                        <Button
                          className="theme-btn-main"
                          style={{ padding: "11px 12px" }}
                          onClick={() =>
                            onManageWorkflow({
                              values,
                              setFieldValue,
                            })
                          }
                        >
                          Manage Workflow
                        </Button>
                      </div>
                      <div className="workflows-list">
                        {values.workflows &&
                          values.workflows.length > 0 &&
                          values.workflows.map((each_work, index) => {
                            // Generate the options array for the number of approvals
                            const options = Array.from(
                              {
                                length:
                                  each_work?.users &&
                                  each_work?.users.length > 0 &&
                                  each_work?.users.length,
                              },
                              (_, i) => ({
                                label: `${i + 1}`,
                                value: i + 1,
                              })
                            );

                            return (
                              <div className="each-work-flow mt-3" key={index}>
                                <div className="d-flex justify-content-between">
                                  <div className="workflow-head">
                                    <span
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {each_work.workflow}
                                    </span>
                                  </div>
                                  <div className="form-group mb-1 d-flex gap-2 align-items-center">
                                    <label
                                      className="form-label mb-0"
                                      htmlFor="category"
                                    >
                                      {`Select Number of ${each_work.workflow}`}
                                      <span style={{ color: "#f00" }}> *</span>
                                    </label>
                                    <div className="form-control-wrap">
                                      <select
                                        className="sop-custom-form-select"
                                        id={`workflows.${index}.no_of_approvals`}
                                        name={`workflows.${index}.no_of_approvals`}
                                        placeholder="Select"
                                        onChange={(option) => {
                                          setFieldValue(
                                            `workflows.${index}.no_of_approvals`,
                                            option?.target.value
                                          );
                                        }}
                                        onBlur={handleBlur}
                                        style={{
                                          width: "100px",
                                          fontSize: "12px",
                                          padding: "6px",
                                        }}
                                      >
                                        <option>Select...</option>
                                        {options &&
                                          options?.length > 0 &&
                                          options.map((option) => {
                                            return (
                                              <option value={option.value}>
                                                {option.label}
                                              </option>
                                            );
                                          })}
                                      </select>
                                      <CustomErrorMessage
                                        name={`noOfApprovals_${index}`}
                                        errors={errors}
                                        touched={touched}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="users mt-2 px-3">
                                  {each_work.users &&
                                    each_work.users.length > 0 &&
                                    each_work.users.map((user, subI) => (
                                      <div
                                        className="each-user d-flex justify-content-between mt-2"
                                        key={subI}
                                      >
                                        <div>
                                          <span>{subI + 1}.</span>
                                          <span
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {user.label}
                                          </span>
                                        </div>
                                        <div>
                                          <img
                                            alt="Cross"
                                            src={Cross}
                                            className="delete-topic"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              let data =
                                                values?.workflows || [];
                                              let users =
                                                data[index].users || [];
                                              users = users.filter(
                                                (each, i) => subI !== i
                                              );
                                              data[index].users = users;
                                              setFieldValue("workflows", data);
                                              setFieldValue(
                                                `workflows.${index}.no_of_approvals`,
                                                ""
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                      {/* {values.workflows &&
                                values.workflows.length > 0 &&
                                values.workflows[0]?.users &&
                                values.workflows[0]?.users.length === 0 && (
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "200px",
                                      height: "200px",
                                      backgroundColor: "white",
                                      padding: "5px",
                                    }}
                                  >
                                    Will Appear Here
                                  </div>
                                )} */}
                    </>
                  )}

                {!digitalSignatureModal && (
                  <div className="mt-3">
                    <div className="d-flex gap-2">
                      <Button
                        className="back-icon-btn-main"
                        onClick={onAddPlant}
                      >
                        <span>{squareBackIcon}</span>
                        <span className="ms-2">Back</span>
                      </Button>
                      <Button
                        className="theme-btn-main"
                        type="submit"
                        disabled={!dirty}
                      >
                        {buttonLoading ? <ButtonLoading /> : "Submit"}
                      </Button>
                      {selectedPlant?.status === "rejected" && (
                        <Button
                          className="theme-btn-main"
                          onClick={() => {
                            if (setting.digital_signature) {
                              setSelectedPlant((prev) => ({
                                ...prev,
                                ...values,
                              }));
                              onDigitalSignatureModal();
                              setReinitiateClicked(true);
                            } else {
                              updateBranchIntiated(values);
                            }
                          }}
                          disabled={!dirty}
                          // onClick={() => {
                          //   updateBranchIntiated(values);
                          // }}
                        >
                          {intiLoading ? (
                            <ButtonLoading />
                          ) : selectedPlant ? (
                            "Submit & Reinitiate"
                          ) : (
                            ""
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <Modal
        centered
        show={approvedModal}
        onHide={onApprovedStatusModal}
        className="add-department-modal-main"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            Update Status
          </Modal.Title>
        </Modal.Header>

        {approvedModal && (
          <Modal.Body className="add-department-modal-body">
            <ApprovalStatusModal
              statusApiFunction={updateWorkflowStatus}
              onClose={onApprovedStatusModal}
              loading={approvedLoading}
            />
          </Modal.Body>
        )}
      </Modal>
      <Modal
        centered
        show={workflowModal}
        onHide={() => onManageWorkflow({})}
        className="add-department-modal-main"
        size="xl"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            Manage Workflow
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="add-department-modal-body">
          <IsWorkflowSlug
            onManageWorkflow={() => onManageWorkflow({})}
            workflowDataSet={workflowDataSet}
          />
        </Modal.Body>
      </Modal>
      <Modal
        centered
        show={digitalSignatureModal}
        onHide={onDigitalSignatureModal}
        className="add-department-modal-main"
        size="md"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            E - Signature
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="add-department-modal-body">
          <CustomDigitalSignature
            digitalSignatureHandleSubmit={
              reinitiateClicked ? updateBranchIntiated : updatePlantMaster
            }
            onDigitalSignatureModal={onDigitalSignatureModal}
            values={selectedPlant}
            isLoading={reinitiateClicked ? intiLoading : buttonLoading}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PlantDetails;
